<div
  class="bg-white px-5 py-4 shadow-(--shadow-input) rounded-2xl transition relative cursor-pointer mb-6 border {{customClass}}"
  [ngClass]="{
    'border-blue-500': isOpen,
    'border-white': !isOpen
  }" (click)="toggleDropdown()">
  <label class="block font-medium text-base text-(--text-secondary)" [id]="labelId">
    {{ label | translate }}
  </label>

  <!-- Selected Option -->
  <div class="flex gap-3 items-center" [attr.aria-labelledby]="labelId">
    <img *ngIf="selectedOption?.icon" [src]="selectedOption.icon" class="w-5 h-5"
      [ngClass]="{'rounded-full': selectedOption.code}" [ngClass]="{'rounded-full': selectedOption.code}" />
    <p class="sm:max-w-full max-w-[88%] font-semibold leading-6 text-base" [ngClass]="{
    'text-(--text-primary)': isOpen || selectedOption,
    'text-(--text-placeholder)': !isOpen
  }">
      {{ (selectedOption?.label | translate) || (placeholder | translate)}}
    </p>
  </div>

  <img [src]="isOpen ? 'assets/icons/arrow-up-sm.svg' : 'assets/icons/arrow-down-sm.svg'" alt="arrow"
    class="absolute right-5 top-1/2 transform -translate-y-1/2 rtl:left-5 rtl:right-auto transition w-4 h-4" />

  <ul *ngIf="isOpen"
    class="absolute left-0 right-0 z-10 bg-white rounded-3xl p-3 md:p-5 max-h-96 [@media(max-height:600px)]:max-h-[200px] overflow-auto shadow-(--shadow-input) transition-all duration-300 ease-out"
    [ngClass]="{
    'top-full mt-2 origin-top': !openUpwards,
    'bottom-full mb-2 origin-bottom': openUpwards
  }">
    <!-- Search input -->
    <app-search *ngIf="isSearchable" [placeholder]="searchPlaceholder || ''" (searchChange)="onSearchChange($event)"
      extraClass="bg-white"></app-search>

    <li *ngFor="let option of filteredOptions"
      class="p-3 md:p-5 cursor-pointer border-b-[0.5px] border-[#DAE1E4] last:border-none text-medium hover:opacity-80 transition flex gap-4"
      (click)="selectOption(option, $event)">
      <img [src]="option.icon" class="w-6 h-6" [ngClass]="{'rounded-full': option.code}" *ngIf="option.icon" />
      {{ option.label | translate }}
    </li>

  </ul>
</div>